import { createFileRoute } from '@tanstack/react-router';

import { PersonAccess } from '~/features/workspace/person/person-access';

/** What a person can open: their records and lists, each open in place to its fields. */
export const Route = createFileRoute('/_app/business/people/$userId/access')({ component: PersonAccess });
